// src/pages/Dashboard.tsx
export default function Dashboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { window.NORTHWIND.staff().then(setRows); }, []);
  return <StaffTable rows={rows} />;
}
